import apiClient from 'services/api';

/* ---------- Portfolio types (used by Profile sub-components) ---------- */

export type PortfolioAsset = {
  id: string;
  kind: 'image' | 'video';
  url: string;
};

export type PortfolioItem = {
  id: string;
  section_id: string | null;
  caption: string | null;
  sort_order: number;
  asset: PortfolioAsset | null;
};

export type PortfolioSection = {
  id: string;
  name: string;
  sort_order: number;
};

export type PublicPortfolio = {
  sections: PortfolioSection[];
  items_by_section: Record<string, PortfolioItem[]>;
  items: PortfolioItem[] | null;
};

/* ---------- Public provider profile ---------- */

export const getProfile = (token: string) =>
  apiClient.get<Kudable.ProfileData>(`/public/providers/${token}`);

export const getReviews = (
  token: string,
  page: number,
  filters: { sort?: string; badge?: string; q?: string } = {},
) => {
  const params: Record<string, string> = {
    page: String(page),
    per_page: '10',
  };
  if (filters.sort && filters.sort !== 'recent') params.sort = filters.sort;
  if (filters.badge && filters.badge !== 'all') params.badge = filters.badge;
  if (filters.q) params.q = filters.q;
  return apiClient.get<Kudable.ReviewsPage>(
    `/public/providers/${token}/reviews`,
    { params },
  );
};

export const getPublicPortfolio = (token: string) =>
  apiClient.get<PublicPortfolio>(`/public/providers/${token}/portfolio`);

export const getSlots = (token: string) =>
  apiClient.get<Kudable.SlotsData>(`/public/providers/${token}/slots`);

/* ---------- Profile actions (used by sub-modals) ---------- */

export const submitBooking = (token: string, body: Kudable.BookingPayload) =>
  apiClient.post<Kudable.BookingCreatedResponse>(
    `/public/providers/${token}/bookings`,
    body,
  );

export const sendMessage = (
  profileToken: string,
  body: Kudable.MessagePayload,
) =>
  apiClient.post<Kudable.MessageSentResponse>(
    `/public/messages/${profileToken}`,
    body,
  );

export const requestProject = (
  profileToken: string,
  body: Kudable.ProjectRequestPayload,
) =>
  apiClient.post<{ thread: { view_token: string; id: string } }>(
    `/public/providers/${profileToken}/project-requests`,
    body,
  );

export const sendReviewInquiry = (
  reviewId: string,
  body: { sender_name: string; sender_email: string; message: string },
) =>
  apiClient.post<{ message: string }>(
    `/public/reviews/${reviewId}/inquire`,
    body,
  );
